/**
 * cs-scroll-reveal.js — Cadouri Superbe
 * Scroll-triggered fade-up reveal using IntersectionObserver.
 * Progressive enhancement: if this script fails, elements stay visible.
 *
 * Strategy: reveal INNER content elements, never whole sections
 * (hiding entire .shopify-section wrappers causes large blank gaps).
 */

(function () {
  'use strict';

  /* ── Respect reduced motion ──────────────────────────── */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Elements to reveal individually ─────────────────── */
  var INDIVIDUAL_SELECTORS = [
    '.title-wrapper',
    '.collection__view-all',
    '.email-signup-banner .newsletter__wrapper',
    '.email-signup-banner .newsletter-form',
    '.collapsible-content__wrapper'
  ];

  /* ── Staggered child groups ──────────────────────────── */
  var STAGGER_GROUPS = [
    { parent: '.slider--desktop', child: '.product-card' },
    { parent: '.slider--mobile',  child: '.product-card' },
    { parent: '.multicolumn-list', child: '.multicolumn-list__item' },
    { parent: '.collection-list', child: '.collection-list__item' },
    { parent: '.collapsible-content', child: 'details' },
    { parent: '.blog-articles', child: '.article' },
    { parent: '.cs-price-brackets__grid', child: '.cs-price-bracket' }
  ];

  /* ── Observer callback ───────────────────────────────── */
  function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cs-revealed');
        observer.unobserve(entry.target);
      }
    });
  }

  /* ── Create observers ────────────────────────────────── */
  var mainObserver = new IntersectionObserver(onIntersect, {
    threshold: 0.15,
    rootMargin: '0px 0px -30px 0px'
  });

  var childObserver = new IntersectionObserver(onIntersect, {
    threshold: 0.1,
    rootMargin: '0px 0px -20px 0px'
  });

  /* ── Init ────────────────────────────────────────────── */
  function init() {
    /* Individual element reveals */
    INDIVIDUAL_SELECTORS.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        el.classList.add('cs-reveal');
        mainObserver.observe(el);
      });
    });

    /* Staggered child reveals */
    STAGGER_GROUPS.forEach(function (cfg) {
      var parents = document.querySelectorAll(cfg.parent);
      parents.forEach(function (parent) {
        parent.classList.add('cs-reveal-stagger');
        var children = parent.querySelectorAll(':scope > ' + cfg.child);
        /* Fallback if :scope not supported */
        if (!children.length) children = parent.querySelectorAll(cfg.child);
        children.forEach(function (child) {
          child.classList.add('cs-reveal');
          childObserver.observe(child);
        });
      });
    });
  }

  /* ── Boot ─────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
